import React, { useState, useEffect, useRef } from "react";
import Tab1Image from "../img/envision/manufacturing/IEC.jpg";
import Tab2Image from "../img/envision/manufacturing/manucybersecurity.jpg";
import Tab3Image from "../img/envision/mechanicalenginering/mechimg3.jpg";
import Tab4Image from "../img/envision/manufacturing/CERT.jpg";
import Tab5Image from "../img/envision/manufacturing/ciip.jpg";
import Tab6Image from "../img/envision/manufacturing/ics.jpg";
import Tab7Image from "../img/envision/manufacturing/gdpr.jpg";
import Tab8Image from "../img/envision/manufacturing/cscf.jpg";
import Tab9Image from "../img/envision/manufacturing/cmmc.jpg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const ManufacturingVeritcalTabs = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay
  const tabContainerRef = useRef(null);
  // const handleTabClick = (tab) => setActiveTab(tab);

  const navigate = useNavigate(); // Initialize navigate

  // const handleKnowMoreClick = () => {
  //        // Navigate to the documentaerospacepage with the specific hash
  //        navigate("/documnetmanufacturepage#documnetmanufacturepageone");
  //      };

  const handleKnowMoreClick = (tabId) => {
    console.log("Navigating to:", tabId);
    navigate(`/documnetmanufacturepage?activeTab=${tabId}#documnetmanufacturepageone`);

    setTimeout(() => {
      const targetElement = document.getElementById("documnetmanufacturepageone");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 700);
  };
  const [isHovered, setIsHovered] = useState(false);
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
  };
  // Autoplay effect to change tabs every 3 seconds (3000ms)
  useEffect(() => {
    let tabInterval;

    if (!isHovered && isAutoPlayActive) {
      tabInterval = setInterval(() => {
        setActiveTab((prevTab) => {
          const nextTabNum = parseInt(prevTab.replace("tab", "")) % 9 + 1;
          return `tab${nextTabNum}`;
        });
      }, 3000);
    }

    return () => clearInterval(tabInterval);
  }, [activeTab, isHovered, isAutoPlayActive]);

  useEffect(() => {
    if (tabContainerRef.current) {
      const container = tabContainerRef.current;
      const activeTabElement = document.getElementById(activeTab);

      if (activeTabElement) {
        // Get the position of the active tab within the container
        const activeTabOffsetTop = activeTabElement.offsetTop;

        // Smoothly scroll the container to that position
        container.scrollTo({
          top: activeTabOffsetTop - container.offsetTop, // Adjust based on the container's offset
          behavior: 'smooth', // Smooth scroll
        });
      }
    }
  }, [activeTab]);

  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      // display: "flex",
      width: "80%",
      margin: "50px auto",
    },
    tabNav: {
      // display: "flex",
      flexDirection: "column",
      borderRight: "1px solid #fff",
      height: "350px",
      overflowY: "auto", // Ensure only vertical scrolling
      scrollbarWidth: "thin", // For Firefox
      scrollbarColor: "#ccc transparent", // For Firefox
      direction: "rtl", // This makes the scrollbar appear on the left side
    },

    tabButton: {
      padding: "15px",
      cursor: "pointer",
      border: "none",
      background: "none",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#555",
      outline: "none",
      transition: "color 0.3s, background-color 0.3s",
      borderRadius: "10px",
      margin: "5px 0",
      backgroundColor: "#f0f0f0",
    },
    activeTabButton: {
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
    },
    card: {
      // display: "flex",
      alignItems: "center",
      padding: "20px",
      borderRadius: "15px",
      backgroundColor: "#fff",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      width: "100%",
      // marginLeft:"10px",
      cursor: "pointer",
      height: "350px",
      overflowY: "auto",
    },
    image: {
      width: "382px",
      height: "274px",
      borderRadius: "10px",
      marginRight: "20px",
    },
    textContent: {
      flex: 1,
      textAlign: "left",
      color: "#333",
      // marginTop:"350px",
      height:"280px"
    },
    icon: {
      marginRight: "10px",
      fontSize: "24px",
      color: "#009ca5",
    },
    dotNav: {
      display: "flex",
      justifyContent: "center",
      marginTop: "10px",
    },
    dot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#ccc",
      margin: "0 5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    activeDot: {
      backgroundColor: "rgb(236 115 34)",
    },
    knowMoreButton: {
      marginTop: "15px",
      padding: "10px 20px",
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
      // marginLeft:"150px"
    },
    knowMoreButtonHover: {
      backgroundColor: "#e68a00",
    },
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>
        <span style={{ color: "rgb(236 115 34)" }}>Regulatory Compliance</span>  Services
      </h1>
      <div style={styles.container} className="tabclass-container-data">
      

        <div
          style={{
            ...styles.tabNav,
            overflowY: 'auto', // Allow scrolling within the container
            scrollBehavior: 'smooth', // Enable smooth scrolling within the container
          }}
          ref={tabContainerRef}
          className="tabdata"
        >
          {[
            'IEC 62443 (International Electro technical Commission Standard 62443)',
            'NIST Cybersecurity Framework (National Institute of Standards and Technology)',
            'CEA Guidelines on Cyber Security in Power Sector, 2021',
            'CERT-In Guidelines (India)',
            'Critical Information Infrastructure Protection (CIIP) Framework',
            'Industrial Control Systems (ICS) Security Guidelines',
            'GDPR (General Data Protection Regulation)',
            'US Cybersecurity Maturity Model Certification (CMMC)',
            'SWIFT Customer Security Controls Framework (CSCF)',

          ].map((tab, index) => {
            const tabId = `tab${index + 1}`;
            return (
              <button
                key={tabId}
                id={tabId}
                style={{
                  ...styles.tabButton,
                  ...(activeTab === tabId
                    ? { ...styles.activeTabButton, backgroundColor: 'rgb(236 115 34)', color: '#fff' }
                    : {}),
                }}
                onClick={() => handleTabClick(tabId)}
                className="tab-button-width"
                onMouseEnter={(e) => {
                  if (activeTab !== tabId) {
                    e.currentTarget.style.backgroundColor = '#000'; // Change background to black on hover
                    e.currentTarget.style.color = '#fff'; // Change text to white on hover
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tabId) {
                    e.currentTarget.style.backgroundColor = ''; // Revert background on mouse leave
                    e.currentTarget.style.color = ''; // Revert text color on mouse leave
                  }
                }}
              >
                {tab}
              </button>
            );
          })}
        </div>

        <div style={styles.card} className="card-data-vertica-tabs"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          <img
            src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, tab6: Tab6Image, tab7: Tab7Image, tab8: Tab9Image, tab9: Tab8Image }[activeTab]}
            alt="Healthcare"
            style={styles.image}
            className="tab-image-data"
          />
          <div style={styles.textContent}

            // className="manfacture-context-text"

            className={`
            ${activeTab === "tab4" } 
      ${activeTab === "tab8" }
       ${activeTab === "tab5" }  
       ${activeTab === "tab6" } 
     
      ${activeTab === "tab7"} 
     
        
            `


            }
          >
            {(() => {
              const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
              const contentArray = [
                [
                  [" The IEC 62443 standard provides a comprehensive framework for cybersecurity in industrial automation and control systems (IACS) across the manufacturing sector. It establishes guidelines for risk assessment, security architecture, and access control, ensuring that connected industrial environments are protected against cyber threats and operational disruptions."],
                  [" Healthcare providers experience fewer equipment failures, lower maintenance costs, and increased uptime of critical medical devices. AI-powered predictive maintenance enhances reliability, ensuring consistent and efficient healthcare service delivery."],
                  [" Regular audits and security assessments by certified evaluators ensure compliance with IEC 62443. Failure to comply may result in increased cyber risk, production downtime, and regulatory penalties, ultimately impacting supply chain security, product integrity, and operational resilience."],
                ],
                [
                  ["The NIST Cybersecurity Framework (CSF) provides guidelines to protect manufacturing systems from cyber threats, ensuring resilience, data integrity, and operational security. It is designed to help manufacturers identify, protect, detect, respond to, and recover from cybersecurity incidents that could disrupt production, compromise intellectual property, or impact supply chain security."],
                  ["The framework emphasizes risk-based cybersecurity practices, including asset management, access control, continuous monitoring, threat intelligence integration, and incident response planning. "],
                  [" Regular risk assessments and cybersecurity audits help manufacturers align with NIST CSF requirements. Non-compliance increases the risk of cyberattacks, production downtime, financial losses, and regulatory penalties, ultimately impacting business continuity and supply chain integrity"]

                ],
                [
                  ["	The CEA (Central Electricity Authority) Guidelines on Cyber Security in Power Sector, 2021 establish a cybersecurity framework for power sector entities, including manufacturers of critical power equipment and industrial control systems (ICS). These guidelines ensure protection against cyber threats targeting the energy supply chain, grid infrastructure, and power generation facilities."],
                  [" The guidelines mandate risk-based cybersecurity measures, secure software development, and network segmentation for Operational Technology (OT) and Industrial Control Systems (ICS). Manufacturers must implement access control, continuous monitoring, data encryption, and real-time ."],
                  [" Regular cybersecurity audits, vulnerability assessments, and compliance checks are required under these guidelines. Failure to comply can result in operational risks, regulatory penalties, or cyber incidents that may disrupt power supply chains and national grid security"],
                  // [" Interoperability and data security audits."]

                ],
                [
                  ["The CERT-In (Indian Computer Emergency Response Team) Guidelines provide cybersecurity best practices and compliance requirements for manufacturing industries to protect industrial control systems (ICS), operational technology (OT), and supply chains from cyber threats. These guidelines are essential for securing critical manufacturing infrastructure, preventing cyberattacks, and ensuring data integrity."],
                  ["Manufacturers must implement robust cybersecurity measures, including network segmentation, multi-factor authentication (MFA), endpoint protection, continuous threat monitoring, and secure remote access protocols. Additionally, compliance requires regular vulnerability assessments, threat intelligence sharing, and incident response planning to mitigate cyber risks."],
                  ["Periodic security audits, incident reporting, and compliance reviews are mandated under CERT-In guidelines. Non-compliance may result in regulatory action, increased exposure to cyber threats, and disruptions in industrial operations, impacting production efficiency and supply chain security"],


                ],
                [
                  ["The Critical Information Infrastructure Protection (CIIP) Framework is designed to safeguard manufacturing sector entities that operate critical infrastructure, including industrial control systems (ICS), SCADA systems, and supply chains, from cyber threats and disruptions. This framework ensures resilience, national security, and operational continuity in the face of cyberattacks, system failures, or sabotage."],
                  ["CIIP mandates risk-based security controls, multi-layered cyber defense strategies, and real-time threat detection for manufacturers handling mission-critical processes, defense manufacturing, and energy sector components. Organizations must implement secure network architectures, access control mechanisms, cybersecurity awareness training, and AI-driven anomaly detection to prevent, detect, and respond to cyber threats effectively."],
                  ["Regular security audits, compliance checks, and vulnerability assessments are required to align with CIIP directives. Failure to comply can result in severe operational risks, regulatory penalties, supply chain vulnerabilities, and potential national security threats, making CIIP compliance critical for manufacturers of essential goods and infrastructure components."],
                  // [" Interoperability and data security audits."]

                ],
                [
                  ["The Industrial Control Systems (ICS) Security Guidelines establish cybersecurity best practices to protect manufacturing facilities, critical infrastructure, and automated industrial environments from cyber threats, operational disruptions, and unauthorized access. As manufacturing becomes more digitized with SCADA systems, IoT-enabled machinery, and smart factories, ICS security is crucial for ensuring resilience, safety, and compliance."],
                  ["These guidelines mandate secure network architectures, access control mechanisms, real-time monitoring, and intrusion detection systems (IDS) for protecting Supervisory Control and Data Acquisition (SCADA), Distributed Control Systems (DCS), and programmable logic controllers (PLCs). Manufacturers must implement multi-layered security, endpoint protection, and secure remote access protocols to reduce the risk of cyberattacks on industrial automation systems. "],
                  [" Regular security audits, vulnerability assessments, and incident response drills are required to maintain compliance. Failure to secure ICS environments can result in production downtime, safety hazards, regulatory penalties, and cyber-physical threats, impacting both operational efficiency and supply chain integrity "]

                ],
                [
                  ["The General Data Protection Regulation (GDPR) applies to manufacturing companies that collect, store, or process personal data of individuals in the European Union (EU). This includes employee records, customer information, supplier details, and IoT-generated data from smart factories. GDPR ensures data privacy, transparency, and accountability, requiring manufacturers to implement strong data protection measures."],
                  ["GDPR mandates data minimization, encryption, and access control to protect personally identifiable information (PII). Manufacturers must ensure lawful data collection, obtain explicit consent, and provide individuals with rights to access, rectify, or erase their personal data. Compliance also requires Data Protection Impact Assessments (DPIAs), real-time breach monitoring, and incident reporting within 72 hours."],
                  ["Regular privacy audits and compliance assessments are required to align with GDPR. Non-compliance can lead to hefty fines (up to €20 million or 4% of annual turnover), reputational damage, and legal liabilities, making GDPR adherence crucial for global manufacturing operations"],

                ],
                [
                  ["The Cybersecurity Maturity Model Certification (CMMC) is a mandatory cybersecurity framework for manufacturers working with the U.S. Department of Defense (DoD) and defense contractors. It ensures that companies handling Federal Contract Information (FCI) and Controlled Unclassified Information (CUI) follow strict cybersecurity standards to protect national security and supply chain integrity. "],
                  ["CMMC mandates five levels of cybersecurity maturity, requiring manufacturers to implement access controls, data encryption, endpoint security, incident response plans, and continuous monitoring. Compliance also includes multi-factor authentication (MFA), secure software development practices, and regular vulnerability assessments to mitigate cyber risks in industrial control systems (ICS) and defense manufacturing processes. "],
                  ["Regular third-party audits and certification assessments determine compliance with CMMC levels. Non-compliance can result in disqualification from DoD contracts, supply chain vulnerabilities, and increased exposure to cyber threats, making CMMC essential for manufacturers in the defense sector"],

                ],
                [
                  ["The SWIFT Customer Security Controls Framework (CSCF) applies to manufacturers that use the SWIFT network for international financial transactions, vendor payments, and supply chain financing. It establishes mandatory security controls to protect financial messaging systems from cyber threats, fraud, and unauthorized access."],
                  ["CSCF mandates multi-factor authentication (MFA), transaction integrity monitoring, real-time fraud detection, and network segmentation to safeguard payment flows and financial communications. Manufacturers must implement endpoint security, access control policies, and continuous security monitoring to prevent cyberattacks targeting SWIFT-connected systems."],
                  ["Annual independent security assessments and audits are required to verify compliance with CSCF. Failure to comply can lead to financial fraud risks, disrupted supply chain payments, regulatory penalties, and reputational damage, making CSCF adherence critical for manufacturers involved in global financial transactions"],

                ],

              ];

              const selectedContent = contentArray[tabIndex] || [];

              return selectedContent.map((listItems, listIndex) => (
                <ul key={listIndex}>
                  {listItems.map((point, itemIndex) => (
                    <li key={itemIndex}>{point}</li>
                  ))}
                </ul>
              ));
            })()}

            {/* <button
                            style={styles.knowMoreButton}
                            onClick={handleKnowMoreClick}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
                        className="know-more-btn"
                        >
                            Know More
                        </button> */}

            {Array.from({ length: 9 }, (_, index) => {
              const tabId = `tab${index + 1}`;
              return (
                activeTab === tabId && (
                  <button key={tabId} onClick={() => handleKnowMoreClick(tabId)}
                    style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                    className="know-more-btn"
                  >
                    Know More
                  </button>
                )
              );
            })}
          </div>
          {/* <div style={styles.textContent}>
            <p style={{textAlign:"justify"}}>
              {[ 
                "The IEC 62443 standard provides a comprehensive framework for cybersecurity in industrial automation and control systems (IACS) across the manufacturing sector. It establishes guidelines for risk assessment, security architecture, and access control, ensuring that connected industrial environments are protected against cyber threats and operational disruptions.",
                "Mandatory annual cybersecurity reviews for organizations to protect critical infrastructure, including manufacturing OT systems, by aligning with global best practices.",
                "Mandatory annual audit for rural and cooperative banks, the National Bank for Agriculture and Rural Development (NABARD) conducts annual audits to assess financial health and compliance with sector-specific regulations",
                "Mandatory annual cybersecurity audits for manufacturers in the power sector, enforcing robust security measures for SCADA and OT systems to safeguard operations from cyber threats.",
                "Mandatory biannual internal and annual external audits for entities managing IT infrastructure, enforcing proactive security measures and incident reporting compliance.",
                "Mandatory annual audits for critical manufacturing sectors to protect essential infrastructure from cyber threats and vulnerabilities.",
                "Mandatory annual ICS/SCADA security audits and periodic vulnerability assessments for manufacturers using OT systems to prevent unauthorized access and cyberattacks.",
                "Mandatory annual data protection audits with continuous monitoring for manufacturers handling EU personal data, enforcing strict security and privacy measures.",
                "Mandatory annual compliance audits for Indian manufacturers supplying to US defense contractors, ensuring the secure handling of sensitive defense-related data.",
                
              ][parseInt(activeTab.replace("tab", "")) - 1]}
            </p>
            <button
              style={styles.knowMoreButton}
              onClick={handleKnowMoreClick}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
            >
              Know More
            </button>
          </div> */}
        </div>
      </div>

      {/* Dot Navigation */}
      <div style={styles.dotNav}>
        {[...Array(9)].map((_, index) => {
          const tab = `tab${index + 1}`;
          return (
            <div
              key={tab}
              style={{
                ...styles.dot,
                ...(activeTab === tab ? styles.activeDot : {}),
              }}
              onClick={() => handleTabClick(tab)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ManufacturingVeritcalTabs;
